/**
 * API client pour le module feedback
 *
 * Appels vers POST /api/feedback
 * Les cookies de session sont envoyés automatiquement (credentials: 'include')
 */

export interface FeedbackPayload {
  /** Contenu du feedback (1-2000 caractères) */
  content: string;
  /** URL de la page courante */
  route: string;
}

export interface FeedbackResponse {
  success: boolean;
  message?: string;
  feedback?: {
    id: number;
    createdAt: string;
  };
  error?: string;
  error_code?: string;
  retryAfter?: number;
}

/**
 * Soumet un feedback au serveur
 * @param payload - Contenu et route du feedback
 * @returns Réponse du serveur
 */
export async function submitFeedback(
  payload: FeedbackPayload
): Promise<FeedbackResponse> {
  try {
    const response = await fetch('/api/feedback', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include', // Envoie les cookies de session
      body: JSON.stringify(payload),
    });

    const data: FeedbackResponse = await response.json();

    // Ajouter le code HTTP pour le traitement côté hook
    if (!response.ok) {
      return {
        ...data,
        success: false,
        error_code: data.error_code || `HTTP_${response.status}`,
      };
    }

    return data;
  } catch (error) {
    // Erreur réseau ou parsing JSON
    console.error('[Feedback API] Erreur:', error);
    return {
      success: false,
      error: 'Impossible de contacter le serveur. Vérifiez votre connexion.',
      error_code: 'NETWORK_ERROR',
    };
  }
}

export default {
  submitFeedback,
};
